import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_Transition, { name: "slideIn" }, {
      default: _withCtx(() => [
        (_ctx.feedbackStore.infoMessage)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.feedbackStore.infoMessage = '')),
              class: "notificationContainer info"
            }, [
              _createElementVNode("h3", null, _toDisplayString(_ctx.feedbackStore.infoMessage), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "slideIn" }, {
      default: _withCtx(() => [
        (_ctx.feedbackStore.successMessage)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.feedbackStore.successMessage = '')),
              class: "notificationContainer success"
            }, [
              _createElementVNode("h3", null, _toDisplayString(_ctx.feedbackStore.successMessage), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "slideIn" }, {
      default: _withCtx(() => [
        (_ctx.feedbackStore.warningMessage)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.feedbackStore.warningMessage = '')),
              class: "notificationContainer warning"
            }, [
              _createElementVNode("h3", null, _toDisplayString(_ctx.feedbackStore.warningMessage), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "slideIn" }, {
      default: _withCtx(() => [
        (_ctx.feedbackStore.dangerMessage)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.feedbackStore.dangerMessage = '')),
              class: "notificationContainer error"
            }, [
              _createElementVNode("h3", null, _toDisplayString(_ctx.feedbackStore.dangerMessage), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}